import coreReducer from './coreSlice';
import sessionReducer from '@/features/session/store/sessionSlice';
import dashboardReducer from '@/features/dashboard/dashboardSlice';
import tagsReducer from '@/features/tags/store/tags.slice';
import createSoftTagReducer from '@/features/createTags/store/createSoftTag.slice';
import assetHierarchyReducer from '@/features/assetHierarchy/store/assetHierarchy.slice';
import backfillReducer from '@/features/backfill/store/backfill.slice.ts';
import bulkImportsHistoryReducer from '@/features/bulkImportsHistory/store/bulkImportsHistory.slice';
import formulaApiReducer from '../features/formulaMate/store/formulaApi.slice';

const rootReducer = {
  reducer: {
    core: coreReducer,
    session: sessionReducer,
    dashboard: dashboardReducer,
    tags: tagsReducer,
    backfill: backfillReducer,
    bulkImportsHistory: bulkImportsHistoryReducer,
    formulaApi: formulaApiReducer,
    createSoftTag: createSoftTagReducer,
    assetHierarchy: assetHierarchyReducer,
  },
};

export default rootReducer;
